<template>
  <div id="app">
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <router-view />
  </div>
</template>
<script>
export default {
  // 以vue2为例
  mounted() {
    return
    //为pc则用iframe把移动端页面显示到页面中间
    let userAgentInfo = window.navigator.userAgent;
    let Agents = new Array(
      "Android",
      "iPhone",
      "SymbianOS",
      "Windows Phone",
      "iPad",
      "iPod"
    );
    //pc
    if (
      !Agents.some((item) =>
        userAgentInfo.toLowerCase().includes(item.toLowerCase())
      ) &&
      !(self.frameElement && self.frameElement.tagName == "IFRAME")
    ) {
      // 检查页面是否已经有iframe   这个判断让页面拥有只保留一个iframe
      let ifrTag = document.getElementsByTagName("iframe")[0];
      if (ifrTag) {
        // 如果有，则删除它
        ifrTag.remove();
      } else {
        let ifrTag = document.createElement("iframe");
        document.body.innerHTML = "";
        ifrTag.setAttribute("src", window.location.href);
        let styleObj = {
          width: "480px",
          height: "920px",
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
        };
        // Object.entries(styleObj).forEach(({ key, value }) => {
        //   ifrTag.style[key] = value;
        // });
        Object.keys(styleObj).forEach((key) => {
          ifrTag.style[key] = styleObj[key];
        });
        document.body.append(ifrTag);
      }
    }
  },
};
</script>
<style lang="scss">
#app {
  font-family: 'sans-serif';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #faf9f5;
  height: 100vh;
  overflow-y: auto;
  padding-top: 130px;
  box-sizing: border-box;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>
